import { css } from '@emotion/react';
import { Divider } from '@frontend/divider';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { DetailCard } from '../../Card/detail-card';
import { PayoutLabel } from '../PayoutLabel';
import { PayoutValue } from '../PayoutValue';

type Destination = {
  accountName: string;
  brand: string;
  country: string;
  currency: string;
  destinationType: string;
  fingerprint: string;
  last4: string;
  routingNumber: string;
  id: string;
};

export const PayoutAccountDetailsCard = ({ loading, destination }: { loading: boolean; destination: Destination }) => {
  const { t } = useTranslation('payments');
  return (
    <DetailCard>
      <Heading level={2}>{t('Account Details')}</Heading>
      <Divider />
      <div
        css={css`
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: ${theme.spacing(3)};
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          <PayoutValue loading={loading} value={destination.accountName} />
          <PayoutLabel>
            {destination.routingNumber}
            {' ****'}
            {destination.last4}
          </PayoutLabel>
        </div>
        <div
          css={css`
            background-color: ${theme.colors.neutral5};
            color: ${theme.colors.neutral40};
            padding: ${theme.spacing(1, 2)};
            border-radius: ${theme.spacing(2.5)};
            margin-left: ${theme.spacing(3)};
            p {
              line-height: 1;
            }
          `}
        >
          <PayoutLabel>{destination.currency.toUpperCase()}</PayoutLabel>
        </div>
      </div>
      <div
        css={css`
          display: grid;
          grid-template-columns: 1fr 2fr;
          max-width: 500px;
          row-gap: ${theme.spacing(1.5)};
          align-items: center;
          text-align: left;
        `}
      >
        <PayoutLabel>{t('Type')}</PayoutLabel>
        <PayoutValue loading={loading} value={destination.destinationType.toUpperCase()} />
        <PayoutLabel>{t('Origin')}</PayoutLabel>
        <PayoutValue loading={loading} value={destination.country} />
        <PayoutLabel>{t('Fingerprint')}</PayoutLabel>
        <PayoutValue loading={loading} value={destination.fingerprint} />
        <PayoutLabel>{t('ID')}</PayoutLabel>
        <PayoutValue loading={loading} value={destination.id} />
      </div>
    </DetailCard>
  );
};
